module.exports = __webpack_public_path__ + "static/media/buttquest.089df01d.png";